import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

interface WhiteLabelStore {
  brand: "thru" | "boomi"
  setBrand: (brand: "thru" | "boomi") => void
  cycleBrand: () => void
}

export const useWhiteLabelStore = create<WhiteLabelStore>()(
  persist(
    (set, get) => ({
      brand: "thru",
      setBrand: (brand: "thru" | "boomi") => {
        set({ brand })
      },
      cycleBrand: () => {
        set((state) => ({ brand: state.brand === "thru" ? "boomi" : "boomi" }))
      },
    }),
    {
      name: "white-label",
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
